import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import type { TranslationType } from '../../StarsSquareIconButton';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../../StarsSquareIconButton.scss';

interface Props {
  subTitle?: React.ReactNode;
  translation: TranslationType;
  boldText?: boolean;
}

const ButtonText: React.FC<Props> = ({ subTitle, translation, boldText = true }) => (
  <>
    <p
      className={classNames(styles.buttonText, {
        [styles.buttonTextBold]: boldText
      })}
    >
      <Translation values={translation?.values} {...translation?.tag} />
    </p>
    {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
  </>
);

export default ButtonText;
